import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import { ApplicationStatus } from 'domain/components/application/ApplicationStatus';
import GroupDetailsResponse from 'features/group-details/GroupDetailsResponse';

interface IAlertRegistration {
  data: GroupDetailsResponse;
}

const AlertRegistration = (props: IAlertRegistration) => {
  if (props.data.appStatusCd !== ApplicationStatus.RULES_ENGINE_COMPLETE) {
    return null;
  }

  // TODO - Alert if registration is new/unread - New flag to table

  function isRulesEngineStatus(statusCd: string) {
    return statusCd === props.data.appStatusCd;
  }
  // Alert if delisted registration - Rules engine status === DELISTED (or something like that)
  if (isRulesEngineStatus('INACTIVE')) {
    return (
      <Alert type={AlertType.warning}>Application has been delisted.</Alert>
    );
  }
  // Alert if revoked - Rules engine status
  else if (isRulesEngineStatus('REVOKED')) {
    return (
      <Alert type={AlertType.warning}>Application has been revoked.</Alert>
    );
  }
  // Alert if recission - Rules engine status
  else if (isRulesEngineStatus('RESCISSION')) {
    return (
      <Alert type={AlertType.warning}>Application has been rescinded.</Alert>
    );
  }

  return null;
  /* TODO:
    Alert if renewal button is active - TODO 
    Alert if expired job is run - i.e., if expired TODO
   */
};

export default AlertRegistration;
